<template>
 <div class="row justify-content-center">

    <div id="loaderoverlay" v-bind:style={display:onloader}>
        <div class="w-100 d-flex justify-content-center align-items-center">
            <div class="loaderspinner"></div>
        </div>
    </div>
    <div class="col-lg-5 col-md-7">
        <div class="card bg-secondary shadow border-0">
                    <div class="card-body px-lg-5 py-lg-5">
                        <div class="text-center text-muted my-3">                           
                            <p class="mt-3">Login with your account credential</p>
                        </div><hr/>
                        <form role="form" @submit.prevent="userlogin">
                            <base-input class="input-group-alternative mb-3" placeholder="Username" addon-left-icon="ni ni ni-single-02" v-model="username">
                            </base-input>
                            <base-input class="input-group-alternative" placeholder="Password" type="password" addon-left-icon="ni ni-lock-circle-open" v-model="password">
                            </base-input>
                            <base-checkbox class="custom-control-alternative">
                                <span class="text-muted">Remember me</span>
                            </base-checkbox>
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary btn-block my-3">Sign in</button>
                            </div>
                        </form>
                        <div class="text-center">
                            <router-link to="/retrievepassword" class="text-primary"><small>Forgot password?</small></router-link>
                        </div>
                        
                    </div>
        </div>
    </div>
</div>
</template>

<script>
import swal from 'sweetalert'
export default {
    name: 'login',
    components: {},
    data() {
        return {
            churchName:null,
            churchLogo:null,
            username: '',
            password: '',
            errormsg: '',
            onloader: 'none'
        }
    },
    methods: {
        userlogin: function () {
            let username = this.username
            let password = this.password
            let accesskey = this.$store.state.auth.accesskey
            this.onloader = 'flex'
            let userdata = {
                username,
                password,
                accesskey
            }
            this.$store.dispatch('login', userdata)
                .then(() => {        
                        this.getchurchbyusername();           
                        this.onloader = 'none'
                        this.$router.push('/dashboard');

                })
                .catch(err => {
                    this.password = ''
                    this.onloader = 'none'
                    if (err.response.data === "Yet to Logon") {
                        this.$router.push('/changepassword')
                    } else {
                        swal({
                            title: "Oops!",
                            text: err.response.data,
                            icon: "error",
                            button: "Ok",
                        });
                    }
                })
        },
        getchurchbyusername: function () {            
            this.$store.dispatch('getchurchbyusername')
                .then((resp) => {                    
                    this.churchName=resp.ChurchName;  
                    if(resp.ChurchLogo!=null){
                        this.churchLogo= this.$store.state.auth.baseurl + resp.ChurchLogo.substr(1)
                    }                 
                })
                .catch(err => {
                   console.log(err);
                })
        },
        getsex: function () {            
            this.$store.dispatch('getsex')
                .then(() => {                   
                                   
                })
                .catch(err => {
                   console.log(err);
                })
        },
        getmaritalstatus: function () {            
            this.$store.dispatch('getmaritalstatus')
                .then(() => {                   
                                   
                })
                .catch(err => {
                   console.log(err);
                })
        },
    },
    mounted() {     
      this.getsex();
      this.getmaritalstatus();
    }
}
</script>

<style>
</style>
